import { useCookies } from "react-cookie"

export const useAuthenticated = () => {
    const [cookies] = useCookies(['e_t']);

    const token = cookies.e_t || '';
    return !!token

}